// test1861
(1861 && 0);
